<template>
  <div class="chain" ref="scrollable">
    <h1 class="title_text padding page-title">
      Расчет цепочки
    </h1>
    <div class="flexRow chain-type-select padding ">
        <castom-select
            placeholder="Выберите плетение"
            :options="chainData.chains"
            :required="isRequired"
            @change="updateChain"
            style="width: 60%"
        />
    </div>
    <transition name="chain-preview-fade">
      <button
          v-if="selectedChain"
          type="button"
          class="chain-preview"
          :class="{ 'chain-preview_empty': imageError }"
          :disabled="imageError"
          @click="openImage"
      >
        <img
            v-show="!imageError"
            class="chain-preview__image"
            :src="chainImageUrl"
            :alt="chainImageAlt"
            @load="imageError = false"
            @error="imageError = true"
        >
        <span v-if="imageError" class="chain-preview__placeholder" aria-hidden="true">
          <img src="../../../images/icons/chain.svg" alt="">
        </span>
        <span class="chain-preview__shade"></span>
        <span class="chain-preview__caption">
          <span>
            <strong>{{ selectedChain.name }}</strong>
            <small>{{ imageError ? 'Фото будет добавлено' : 'Нажмите, чтобы увеличить' }}</small>
          </span>
          <span v-if="!imageError" class="chain-preview__expand" aria-hidden="true">
            <i></i><i></i>
          </span>
        </span>
      </button>
    </transition>
    <div class="chain-type-switchers padding flexRow"  style="padding-bottom: 20px">
      <div v-if="coefficientMode === 'custom'" class="chain-type-switchers-switcher flexColumn">
        <div>
          Свой коэффициент плотности
        </div>
        <castomSwitcher
            id="1"
            width="20"
            toggleSize="25"
            height="15"
            style="width: auto;"
            v-model="isOwnKoef"
        />
      </div>
      <div class="chain-type-switchers-switcher flexColumn">
        <div>
          Своя плотность металла
        </div>
        <castomSwitcher
            id="3"
            width="20"
            toggleSize="25"
            height="15"
            style="width: auto;"
            v-model="isOwnSample"
        />
      </div>
    </div>
    <div class="chain-select-metal flexRow padding" style="margin-bottom: 30px" v-if="!isOwnSample">
      <SelectMetal
          v-model="selectedMetal"
          style="width: 50%"
      />
    </div>
    <div class="chain-select-density flexColumn padding" v-if="!isOwnSample">
        <div class="pb10px">
          Выберите пробу
        </div>
        <castom-select
            :dropdownHeight="'140px'"
            :placeholder="'Проба'"
            :options="density"
            :required="isRequired"
            style="width: 80px;"
            @change="updateDensity"
        />

    </div>
    <div class="chain-select-density flexColumn padding" v-if="isOwnSample">
      <div class="pb10px">
        Плотность г/см куб
      </div>
      <CastomInput
          padding="5px"
          style="width: 30%;"
          v-model="chainParams.density"
          :required="isRequired"
      />
    </div>

    <div class="chain-inputs padding flexRow">
      <div class="chain-inputs-input">
        <div>
          Желаемая длинна см.
        </div>
        <CastomInput
            padding="5px"
            v-model="chainParams.long"
            :required="isRequired"
        />
      </div>
      <div class="chain-inputs-input">
        <div>
          Желаемый итоговый вес, г.
        </div>
        <CastomInput
            padding="5px"
            v-model="chainParams.weight"
            :required="isRequired"
        />
      </div>
      <div class="chain-inputs-input" v-if="coefficientMode === 'custom' && isOwnKoef">
        <div>
          Коэффициент плотности
        </div>
        <CastomInput
            padding="5px"
            v-model="chainParams.k"
            :required="isRequired"
        />
      </div>
      <div class="chain-inputs-input" v-if="coefficientMode === 'select'">
        <div>
          Коэффициент плотности
        </div>
        <castom-select
            :key="selectedChain?.id"
            :options="coefficientOptions"
            placeholder="Коэффициент"
            :required="isRequired"
            @change="updateCoefficient"
        />
      </div>
<!--      <div class="chain-inputs-input" v-if="isOwnDiameter">-->
<!--        <div>-->
<!--          Толщина проволоки-->
<!--        </div>-->
<!--        <CastomInput-->
<!--            padding="5px"-->
<!--            v-model="chainParams.diameter"-->
<!--        />-->
<!--      </div>-->
<!--      <div class="chain-inputs-input" v-if="isOwnRigelDiameter">-->
<!--        <div>-->
<!--          Диаметр ригеля-->
<!--        </div>-->
<!--        <CastomInput-->
<!--            padding="5px"-->
<!--            v-model="chainParams.rigelDiameter"-->
<!--        />-->
<!--      </div>-->
    </div>
    <button
        @click="calculateClick"
        class="button-chain"
    >
      Рассчитать
    </button>
    <div
        class="chain-results flexColumn"
        v-if="validationResult"
    >
      <div
          class="chain-results-string flexRow"
          v-for="(item, index) in result.res"
          v-show="item.type"
          :key="index + item.type"
      >
        <div class="chain-results-string_title">{{ item.name }}</div>
        <div class="chain-results-string_num">{{ item.value }}</div>
        <div class="chain-results-string_type">{{ item.type }}</div>
      </div>
      <div
        class="chain-results-string flexRow"
        v-if="metalCost"
      >
        <div class="chain-results-string_title">Стоимость</div>
        <div class="chain-results-string_num">{{ formatPrice(metalCost) }}</div>
        <div class="chain-results-string_type">₽</div>
      </div>
    </div>
    <information-popup
      description="Мы старались сделать калькулятор максимально точным и полезным, но, пожалуйста, учитывайте, что каждый мастер работает по-своему: у всех разные подходы, оборудование и даже личные предпочтения в расчётах.
                   Поэтому итоговые значения могут немного отличаться от реальности — и это нормально. Мы здесь, чтобы помочь с ориентиром, а не заменить опыт мастера.
                   Если что-то вызывает сомнение или хочется поделиться своим мнением — в описании бота есть ссылка на беседу. Нам важно ваше мнение, и мы действительно читаем каждое сообщение 💬"
    />
    <div
        v-if="isImageOpen"
        class="chain-photo-modal"
        role="dialog"
        aria-modal="true"
        :aria-label="chainImageAlt"
        @click.self="closeImage"
    >
      <button type="button" class="chain-photo-modal__close" @click="closeImage" aria-label="Закрыть">×</button>
      <img :src="chainImageUrl" :alt="chainImageAlt">
      <div class="chain-photo-modal__title">{{ selectedChain.name }}</div>
    </div>
  </div>
</template>

<script setup>
import CastomSwitcher from "@/components/switchers/CastomSwitcher"
import CastomSelect from "@/components/selects/CastomSelect"
import {useCalculator} from "@/helpers/chains"
import {computed, reactive, ref, watch} from "vue"
import metalDensity from "@/jsonData/metalDensity.json"
import chainData from "@/jsonData/ChainsData.json"
import SelectMetal from "@/components/selects/SelectMetal"
import CastomInput from "@/components/inputs/CastomInput"
import {createObjectsArray} from "@/helpers/chains"
import InformationPopup from "@/components/popups/InformationPopup";
import {useUserStore} from "@/stores/user/userStore";
import { useMetalsStore } from "@/stores/metalsPrice/metalsStore";
import { formatPrice } from "@/helpers/helpers";
import { trackCalculation } from '@/helpers/calculationAnalytics'

const userTg = useUserStore()
const metalsStore = useMetalsStore()

const { calculate } = useCalculator();
const selectedMetal = ref('silver')
const selectedChain = ref(null)
const imageError = ref(true)
const isImageOpen = ref(false)
const isOwnKoef = ref(false)
const isOwnSample = ref(false)
const isOwnDiameter = ref(false)
const isOwnRigelDiameter = ref(false)
const isRequired = ref(false)

const scrollable = ref(null)
// eslint-disable-next-line no-unused-vars
if (window.gtag) {
  window.gtag('event', 'chain_calculator', {})
}
const chainParams = reactive({
  long: 0, //в см
  weight: 0, // в граммах
  // diameter: 0, // в мм
  // rigelDiameter: 0, // в мм
  type: 0,
  density: 0, //г на см куб
  k: 0 // коэф
})
const result = reactive({
  res: []
})
const density = computed(()=>{
  if(isOwnSample.value) {
    return {density: chainParams.density, name: 'Своя'}
  } else {
    return selectedMetal.value ==='silver'? metalDensity.silver : metalDensity.gold
  }
})
const coefficientMode = computed(() => selectedChain.value?.coefficientMode || 'custom')
const coefficientOptions = computed(() => (selectedChain.value?.coefficientOptions || []).map(value => ({
  name: String(value),
  value
})))

const selectedDensityOption = ref(null)
const assayValue = computed(() => {
  if (isOwnSample.value) return null
  return selectedDensityOption.value?.value ? Number(selectedDensityOption.value.value) : null
})

const metalRate = computed(() => {
  if (!metalsStore?.data) return 0
  return selectedMetal.value === 'gold'
    ? Number(metalsStore.data.gold || 0)
    : Number(metalsStore.data.silver || 0)
})

const chainWeightValue = computed(() => {
  const fromParams = Number(chainParams.weight) || 0
  if (fromParams > 0) return fromParams
  const fromRes = (result.res ?? []).find(r => r?.name === 'Вес' && Number(r.value) > 0)
  return fromRes ? Number(fromRes.value) : 0
})

const metalCost = computed(() => {
  const w = chainWeightValue.value
  const rate = metalRate.value || 0
  const assay = assayValue.value
  if (!w || !rate || !assay) return null
  const cost = w * rate * (assay / 1000)
  return Number.isFinite(cost) ? cost.toFixed(2) : null
})
const isValid = computed(() => {
  return Object.values(chainParams).every(value => value !== 0);
});
const validationResult = computed(()=>{
  let res = true
  result.res.forEach((res)=>{
    if (res.value) {
      res = false
    }
  })
  if(result.res.length === 0) res = false
  return res
})
const updateDensity = (selectedOption) => {
  if (selectedOption) {
    chainParams.density = selectedOption.density;
    selectedDensityOption.value = selectedOption
  }
};
const updateCoefficient = (selectedOption) => {
  chainParams.k = Number(selectedOption?.value) || 0
  resCancel()
};
const updateChain = (selectedOption) => {
  if (selectedOption) {
    const isImageChanged = selectedChain.value?.image !== selectedOption.image
    selectedChain.value = selectedOption
    if (isImageChanged) imageError.value = true
    isImageOpen.value = false
    isOwnKoef.value = false
    chainParams.k = selectedOption.coefficientMode === 'select' ? 0 : selectedOption.k;
    chainParams.type = selectedOption.id;
    resCancel()
  }
};
const chainImageUrl = computed(() => {
  return selectedChain.value?.image
    ? `/img/chains/${selectedChain.value.image}`
    : ''
})
const chainImageAlt = computed(() => {
  return selectedChain.value ? `Плетение ${selectedChain.value.name}` : 'Плетение цепи'
})
const openImage = () => {
  if (!imageError.value && chainImageUrl.value) isImageOpen.value = true
}
const closeImage = () => {
  isImageOpen.value = false
}
const calculateClick = () => {
  setTimeout(()=> {
    scrollToBottom()
  }, 500)
  isRequired.value = true
  if (isValid.value) {
    result.res = calculate(chainParams)
    result.res = createObjectsArray(result.res)
    trackCalculation('chains', {
      chain_id: String(selectedChain.value?.id || ''),
      chain_name: selectedChain.value?.name || '',
      metal: selectedMetal.value === 'gold' ? 'gold' : 'silver',
    })
    const tgUserId = window.Telegram?.WebApp?.initDataUnsafe?.user?.id
    if (tgUserId) {
      userTg.useAchievement(tgUserId, 2)
    }

  }

}
const scrollToBottom = () => {
  if (scrollable.value) {
    scrollable.value.scrollTo({
      top: scrollable.value.scrollHeight,
      behavior: 'smooth',
    });
  }
};
const resCancel = () => {
  result.res = []
}
watch((selectedMetal), () => {
  if(!isOwnSample.value) {
    chainParams.density = 0
    selectedDensityOption.value = null
    resCancel()
  }
})
watch((isOwnSample), () => {
  chainParams.density = 0
  selectedDensityOption.value = null
  resCancel()
})
watch((isOwnDiameter), () => {
  chainParams.diameter = 0
  resCancel()
})
watch((isOwnRigelDiameter), () => {
  chainParams.rigelDiameter = 0
  resCancel()
})

</script>

<style lang="scss">
.chain{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 140px);
  overflow-y: auto;
  padding-bottom: 10px;
  &-type {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &-switchers {
      justify-content: space-around;
      color: white;
      gap: 30px;
      font-size: 14px;
      align-items: center;
      &-switcher {
        gap: 15px;
        align-items: center;
        text-align: center;
        font-size: 12px;
      }
    }
    &-select {
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }
  &-select {
    &-metal {
      color: white;
      justify-content: center;
    }
    &-density {
      color: white;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }
  &-inputs {
    justify-content: space-around;
    gap: 10px;
    &-input {
      display: grid;
      gap: 5px;
      width: 25%;
      text-align: center;
      color: white;
      font-size: 12px;
    }
  }
  &-results {
    margin-top: 20px;
    margin-bottom: 20px;
    border-radius: 25px;
    border: 2px solid #fff;
    height: auto;
    padding: 10px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.25);
    background: linear-gradient(180deg, rgba(181, 162, 189, 0.33) 0%, rgba(26, 21, 28, 0.33) 100%);
    gap: 7px;
    &-string {
      color: white;
      justify-content: flex-start;
      &_title {
        margin-right: auto;
      }
      &_num {
        margin-right: 12px;
      }
    }
  }
}
.chain-preview {
  position: relative;
  display: block;
  flex: 0 0 auto;
  width: 100%;
  height: clamp(100px, 27vw, 128px);
  margin: 10px 0 6px;
  padding: 0;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 20px;
  background: rgba(20, 20, 35, 0.55);
  color: #fff;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: transform 0.14s ease, border-color 0.14s ease;

  &:active:not(:disabled) {
    transform: scale(0.99);
  }

  &:focus-visible {
    outline: 2px solid #5db7b7;
    outline-offset: 3px;
  }

  &_empty {
    cursor: default;
  }

  &__image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  &__placeholder {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(41, 5, 95, 0.34), rgba(93, 183, 183, 0.16));

    img {
      width: 58px;
      height: 58px;
      opacity: 0.35;
      filter: invert(1);
    }
  }

  &__shade {
    position: absolute;
    inset: 40% 0 0;
    background: linear-gradient(180deg, transparent, rgba(9, 8, 18, 0.82));
    pointer-events: none;
  }

  &__caption {
    position: absolute;
    right: 14px;
    bottom: 12px;
    left: 14px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px;

    > span:first-child {
      display: flex;
      min-width: 0;
      flex-direction: column;
      gap: 2px;
    }

    strong {
      overflow: hidden;
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    small {
      color: rgba(255, 255, 255, 0.62);
      font-size: 10px;
      font-weight: 400;
    }
  }

  &__expand {
    position: relative;
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    border: 1px solid rgba(255, 255, 255, 0.55);
    border-radius: 9px;

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 7px;
      height: 7px;
    }

    &::before {
      top: 6px;
      right: 6px;
      border-top: 1.5px solid #fff;
      border-right: 1.5px solid #fff;
    }

    &::after {
      bottom: 6px;
      left: 6px;
      border-bottom: 1.5px solid #fff;
      border-left: 1.5px solid #fff;
    }

    i {
      display: none;
    }
  }
}

.chain-preview-fade-enter-active,
.chain-preview-fade-leave-active {
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.chain-preview-fade-enter-from,
.chain-preview-fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.chain-photo-modal {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(8, 6, 18, 0.92);

  > img {
    display: block;
    width: min(100%, 760px);
    max-height: 75vh;
    object-fit: contain;
    border-radius: 18px;
  }

  &__close {
    position: absolute;
    top: max(18px, env(safe-area-inset-top));
    right: 18px;
    width: 42px;
    height: 42px;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    font-size: 26px;
    line-height: 1;
    cursor: pointer;
  }

  &__title {
    position: absolute;
    bottom: max(24px, env(safe-area-inset-bottom));
    left: 50%;
    padding: 8px 14px;
    border-radius: 12px;
    background: rgba(20, 20, 35, 0.78);
    color: #fff;
    font-size: 14px;
    transform: translateX(-50%);
    white-space: nowrap;
  }
}
.padding {
  border: 2px solid white;
  border-left: none;
  border-right: none;
  border-bottom: none;
  padding: 10px 0;
}
.flexColumn {
  display: flex;
  flex-direction: column;
}
.flexRow {
  display: flex;
  flex-direction: row;
}
.pb10px {
  padding-bottom: 10px;
}
.button-chain {
  background: rgba(0, 0, 0, 0.22);
  color: rgba(255, 255, 255, 0.98);
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.2px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  cursor: pointer;
  padding: 14px 20px;
  margin-top: 20px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: transform 0.08s ease, filter 0.18s ease;
  user-select: none;
}
.button-chain:active {
  transform: translateY(1px) scale(0.99);
  filter: brightness(0.96);
}
.title_text {
  color: white;
  width: 100%;
  text-align: center;
}
</style>
